export default __webpack_public_path__ + "static/media/survey-data.3feb2212.svg";